import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { TranslatePipe } from '@gallaghercp/core-frontend-contracts';

@Component({
    selector: 'core-timeline-chart',
    templateUrl: './block-timeline-chart.component.html',
    styleUrls: [
        '../../scss/block-leave-of-absence-tool-charts.scss',
        '../../scss/block-leave-of-absence-tool-questions.scss',
        '../../scss/block-leave-of-absence-tool-timeline.scss',
    ],
    imports: [TranslatePipe],
})
export class BlockTimelineChartComponent extends BlockAbstractComponent implements OnInit, OnChanges {
    @Input() selectedAnswers: Record<string, any> = {};
    @Input() chartReference: string = '';
    @Input() timelineChartData: any[] = [];

    // Section text strings
    introParagraphText!: string;
    lengthOfLeaveText!: string;
    payText!: string;
    processChecklist!: string;
    thingsToConsider!: string;

    filteredChartData: any[] = [];

    override ngOnInit() {
        this.filterChartData();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['timelineChartData'] || changes['chartReference']) {
            this.filterChartData();
        }
    }

    filterChartData() {
        const data = this.timelineChartData || this.block?.data?.timelineChartData;
        if (this.chartReference) {
            this.filteredChartData = data?.filter(
                (item: { chartReference: string }) => item.chartReference === this.chartReference,
            );
        } else {
            this.filteredChartData = data;
        }
    }
}
